/* eslint-disable import/first */
import React, { useState, useContext } from 'react';

/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { CircularProgress, Divider, Drawer, Typography, Grid } from '@material-ui/core';
import { RiMenu2Line } from '@react-icons/all-files/ri/RiMenu2Line';

import { FormattedMessage } from 'react-intl';
const { selectLoginStatus } = Slices.authSlice;
const { selectCurrentCountry } = Slices.profileSlice;

const { selectDesktop } = Slices.appSlice;
import { Context } from '../Multi-lang/Wrapper';
import SideMenuProfileCard from './ProfileCard';
import SideMenuRouteCard from '../MenuRouteCard';
import { navList } from './RouteConstants';
import CountrySelection from '../CountryDropdown';
import LanguageButton from '../LanguageButton';
import { Badge, SideNavMenuIcon } from '../Icons';
import LangIcon from './images/language.svg';
import closeIcon from './images/close.svg';
import css from './index.module.scss';
import { hamburgerMenuGA } from 'spwa-ui-library/esm/utils/helperGA';

import GlobeIcon from './images/globe.svg';

const { selectCountryValidations } = Slices.configSlice;

export default function SideMenu() {
  const context = useContext(Context);

  const [isMenuOpen, setMenuOpen] = useState(false);
  const isLoggedIn = useSelector(selectLoginStatus);
  const currentCountry = useSelector(selectCurrentCountry);
  const isDesktop = useSelector(selectDesktop);

  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, currentCountry)
  );
  const countryCode = countryValidations?.defaultCCode;

  const [loading] = React.useState(false);

  const toggleMenu = (e) => {
    if (e) {
      e.preventDefault();
    }
    hamburgerMenuGA(isMenuOpen);
    return setMenuOpen(!isMenuOpen);
  };

  // React.useEffect(() => {
  //   if (menu.status === 'succeeded') {
  //     setSwitchCountry(menu.entities[1].countryId);
  //   }
  // }, [menu.entities, menu.status]);

  const handleLanguageChange = (lang) => {
    context.selectLanguage(lang === 'en' ? 'ar' : 'en');
  };

  return (
    <>
      <div className={css.topNav} onClick={toggleMenu}>
        {!isDesktop ? <RiMenu2Line className={css.iconBlack} /> : <SideNavMenuIcon />}
      </div>

      {loading ? (
        <div className={css.loading}>
          <CircularProgress color="secondary" />
        </div>
      ) : (
        ''
      )}

      <Drawer
        anchor={context.locale === 'en' ? 'left' : 'right'}
        open={isMenuOpen}
        onClose={toggleMenu}
        className={css.zIndx}
      >
        <nav className={css.mainNav}>
          <div className={css.closeButton}>
            <div className={css.closeImg} onClick={toggleMenu}>
              <img src={closeIcon} alt="close" />
            </div>
          </div>
          <SideMenuProfileCard setMenuClose={toggleMenu} isLoggedIn={isLoggedIn} />
          <div className={css.dividerArea}>
            <Divider />
          </div>

          <Grid className={css.languageSelectArea}>
            <div className={css.langIcon}>
              <img src={LangIcon} alt="language icon" />
            </div>
            <div className={css.langSection}>
              <div className={css.langTitle}>
                <Typography className={css.languageTypo}>
                  <FormattedMessage id="choose_lang" defaultMessage="Choose Language" />
                </Typography>
              </div>
              <div className={css.langButton}>
                <LanguageButton
                  sideMenu={true}
                  handleClick={handleLanguageChange}
                  lang={context.locale}
                />
              </div>
            </div>
          </Grid>
          {/* TODO: uncomment this line for multicountry */}
          <Grid className={css.countrySelect}>
            <img src={GlobeIcon} />
            <CountrySelection countryCode={`${currentCountry} (${countryCode})`} />
          </Grid>

          <div className={css.dividerAreaOne}>
            <Divider />
          </div>
          <SideMenuRouteCard setMenuClose={toggleMenu} navList={navList.userAccessMenu} />
          <Divider />
          <SideMenuRouteCard setMenuClose={toggleMenu} navList={navList.informationMenu} />
          <Divider />
          <SideMenuRouteCard navList={navList.supportMenu} />
        </nav>
      </Drawer>
    </>
  );
}
